import PropTypes from 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import rison from 'rison-node';
import { omit } from '@dbh/lodash-extra';
import { DBH_QUERY_PARAMETER_NAME, decodeQueryParameter } from '@dbh/make-api-url';

/**
 * Encodes the `+` character in the given `URL`.
 * The `+` character in a URL will be interpreted as a space in query parameters;
 * therefore, to represent an actual plus sign, it must be percent-encoded as `%2B`.
 * This code removes the question mark at the beginning of the string and encodes the
 * `+` (plus sign) in the `email` query parameter. This front end encoding is a fallback,
 * because the backend should encode `+` in the links it prints in the emails.
 * @example from: `test+123@daybreakhotels.com` to: `test%2B123@daybreakhotels.com`.
 * @param {string} url .
 * @return {string} The encoded `URL`.
 */const encodePlusSign=withConformsTo("encodePlusSign",["url",PropTypes.string.isRequired],a=>a.replace(/^[^?]*\?|(email=[^&]*)\+/g,(a,b)=>b?b+"%2B":""));var encodePlusSign$1 = encodePlusSign;

const defaultOptions={dbhQueryParameterOnly:!1},extractQueryParametersFromUrl=withConformsTo("extractQueryParametersFromUrl",[],(a,b)=>{if(!a)return {};const{dbhQueryParameterOnly:c}={...defaultOptions,...b},d=encodePlusSign$1(a),e=new URLSearchParams(d),f=e.get(DBH_QUERY_PARAMETER_NAME);// The `+` character in a URL will be interpreted as a space in query parameters;
// therefore, to represent an actual plus sign, it must be percent-encoded as `%2B`.
// This code removes the question mark at the beginning of the string and encodes the
// `+` (plus sign) in the `email` query parameter. This front end encoding is a fallback,
// because the backend should encode `+` in the links it prints in the emails.
// @example from: `test+123@daybreakhotels.com` to: `test%2B123@daybreakhotels.com`.
// Decode the `dbhq` parameter, if exists.
let g={};if(f){// Decode the query before passing it to `rison` because it was encoded,
// with `@dbh/make-api-url/urlEncoders#encodeQueryParameter`
// in 'makeUrlWithQuery'.
const a=decodeQueryParameter(f);g=rison.decode(a);}// If other parameters are allowed, we add them.
let h={};c||(h=omit(Object.fromEntries(e.entries()),DBH_QUERY_PARAMETER_NAME));// If `dbhQueryParameterOnly` is false, and if "something=other" is in
// `traditionalParameters`, and `something:another` is in `risonParameters`,
// something will be "another" in the output.
const i={...h,...g};return i});/**
 * Extracts and returns the query parameters in the given `URL`.
 * @param {string?} url .
 * @param {Object?} options .
 * @param {boolean} options.dbhQueryParameterOnly If `true`, only take the
 * values inside the `dbhq` `rison` format query parameter.
 * @return {Immutable.Map} Empty if a falsy `URL` is passed.
 */var extractQueryParametersFromUrl$1 = extractQueryParametersFromUrl;

const isUtmQueryParameterKey=withConformsTo("isUtmQueryParameterKey",[],a=>["utm_source","utm_medium","utm_campaign","utm_term","utm_id","utm_content"].includes(a));var isUtmQueryParameterKey$1 = isUtmQueryParameterKey;

/**
 * Extracts and returns the `UTM` query parameters in the given `URL`.
 * @param {string?} url .
 * @return {Object} Empty if a falsy `URL` is passed.
 */const extractUtmQueryParametersFromUrl=withConformsTo("extractUtmQueryParametersFromUrl",[],a=>{// The `+` character in a URL will be interpreted as a space in query parameters;
// therefore, to represent an actual plus sign, it must be percent-encoded as `%2B`.
// This code removes the question mark at the beginning of the string and encodes the
// `+` (plus sign) in the `email` query parameter. This front end encoding is a fallback,
// because the backend should encode `+` in the links it prints in the emails.
// @example from: `test+123@daybreakhotels.com` to: `test%2B123@daybreakhotels.com`.
const b=encodePlusSign$1(a),c=new URLSearchParams(b),d=[...c.entries()],e=d.reduce((a,b)=>{let[c,d]=b;if(isUtmQueryParameterKey$1(c)){const b=a[c];a[c]=b?"string"==typeof b?[b,d]:[...b,d]:d;}return a},{});// Work around for lack of reduce support on `URLSearchParams.entries()`,
// in `Safari`.
return e});var extractUtmQueryParametersFromUrl$1 = extractUtmQueryParametersFromUrl;

export { encodePlusSign$1 as encodePlusSign, extractQueryParametersFromUrl$1 as extractQueryParametersFromUrl, extractUtmQueryParametersFromUrl$1 as extractUtmQueryParametersFromUrl, isUtmQueryParameterKey$1 as isUtmQueryParameterKey };
